var $38dc782dae76851a$exports = {};
$38dc782dae76851a$exports = {
    "collapse": `Skjul`,
    "expand": `Utvid`
};


export {$38dc782dae76851a$exports as default};
//# sourceMappingURL=nb-NO.module.js.map
